// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Suspense_overlay__5LTJE","appDisabled":"Suspense_appDisabled__3i1Ir","busyNetwork":"Suspense_busyNetwork__3Co2F","loader":"Suspense_loader__PEFYt"};